import { Injectable } from "@angular/core";
import { Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import firebase from 'firebase';
import { JobberModel } from '../models/jobber.model';

@Injectable()
export class JobberService {
    constructor(public http: Http) { }

    pushApplicantData(jobberApplication: JobberModel): Promise<void> {

        var ref = firebase.database().ref('/jobApplications');

        return new Promise((resolve, reject) => {
            ref.child(jobberApplication.uid).set(jobberApplication).then(() => {
                resolve();
            }).catch(error => reject());
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/job.service.ts